<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.orderNo"
        placeholder="请输入订单编号"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.goodsName"
        placeholder="请输入商品名称"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.userId"
        placeholder="请输入Id"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <DataPicker
        @valueFunc="getPickerValueFunc"
        paramsType="apply"
        startPlaceholder="下单开始时间"
        endPlaceholder="下单截止时间"
      />
      <el-select
        v-model="listQuery.financeStatus"
        placeholder="结算状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in option1"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-select
        v-model="listQuery.goodsType"
        placeholder="请选择商城区域"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in option2"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>

      <el-select
        v-model="listQuery.afterType"
        placeholder="请选择是否可退货"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in option3"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>

      
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        style="margin-left: 10px"
        >搜索</el-button
      >
      <JsonExcel
        :data="list"
        style="margin-left: 10px"
        :fields="fields"
        name="订单结算表.xls"
      >
        <el-button
          class="filter-item"
          icon="el-icon-download"
          >导出</el-button
        >
      </JsonExcel>
      
    </div>
    <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="setBatchSettlementOrder"
        style="margin-bottom: 20px"
        >批量结算</el-button
      >
    <!-- <div style="margin-bottom: 5px">提现数量:{{ total }}</div> -->

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      ref="table"
      @selection-change="handleSelectionChange"
      border
      fit
      highlight-current-row
    >
     <el-table-column
      type="selection"
      width="55">
    </el-table-column>
      <el-table-column
        align="center"
        prop="orderNo"
        label="订单号"
      ></el-table-column>
      <el-table-column label="结算状态" align="center">
        <template slot-scope="scope">
          {{ option1[scope.row.financeStatus].value }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="ctdate"
        label="下单时间"
      >
        <template slot-scope="scope">
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="产品名称"
        align="center"
        prop="title"
      ></el-table-column>
      <el-table-column
        label="产品图片"
        align="center"
        prop="mainGraph"
      >
        <template slot-scope="scope">
          <el-image
            style="width: 100px; height: 100px"
            :src="scope.row.mainGraph"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column label="商城区域" align="center">
        <template slot-scope="scope">
          {{ option2[scope.row.goodsType].value }}
        </template>
      </el-table-column>
      <el-table-column label="订单状态" align="center">
        <template slot-scope="scope">
          {{ option5[scope.row.status].value }}
        </template>
      </el-table-column>
      <el-table-column
        label="产品数量"
        align="center"
        prop="buyNum"
      ></el-table-column>
      <el-table-column
        label="销售价"
        align="center"
        prop="minPrice"
      ></el-table-column>
      <el-table-column
        label="采购价"
        align="center"
        prop="supplyPrice"
      ></el-table-column>
      <el-table-column
        label="订单金额"
        align="center"
        prop="goodsAmount"
      ></el-table-column>
      
     <el-table-column label="支付方式" align="center">
        <template slot-scope="scope">
          {{ option4[scope.row.payPlatform] }}
        </template>
      </el-table-column>
      <el-table-column
        label="渠道费(支付收取)"
        align="center"
        prop="fee"
      ></el-table-column>
      <el-table-column
        label="会员UID"
        align="center"
        prop="userId"
      ></el-table-column>
      <el-table-column label="是否可退货" align="center">
        <template slot-scope="scope">
          {{ option3[scope.row.afterType].value }}
        </template>
      </el-table-column>
     
      <el-table-column
        label="操作"
        align="center"
        width="100"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="setBatchSettlementOrder([scope.row.id])"
            class="comm_but_warp"
            v-if="scope.row.financeStatus === 0"
            >结算</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    
  </div>
</template>

<script>

import JsonExcel from "vue-json-excel";
import { getSettlementList,exportOrderFinance,batchSettlementOrder, exportList, feedback,getWithdrawRecordList,wechatCancelTransfer } from "@/api/finance";
import { formatApiDate } from "@/utils/utils";
import { uploadXlsx } from "@/utils/index";
import {
  DIALOG_TITLE_TYPE,
  getValue,
  FINANCE_WITHDRAWAL_STATUS,
  ACCOUNT_CATEGORY,
  ACCOUNT_TYPE,
  UPLOAD_IMG_TYPE
} from "@/utils/enumUtile";
import UploadList from "@/views/components/uploadList";
import DataPicker from "@/views/components/dataPicker";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    DIALOG_TITLE_TYPE() {
      return DIALOG_TITLE_TYPE;
    },
    FINANCE_WITHDRAWAL_STATUS() {
      return FINANCE_WITHDRAWAL_STATUS;
    },
    ACCOUNT_CATEGORY() {
      return ACCOUNT_CATEGORY;
    },
    ACCOUNT_TYPE() {
      return ACCOUNT_TYPE;
    },
    UPLOAD_IMG_TYPE() {
      return UPLOAD_IMG_TYPE;
    }
  },
  components: { UploadList, DataPicker,JsonExcel },
  filters: {},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      fields:{
        '订单号':'orderNo',
        '结算状态':'financeStatusOne',
        '下单时间':'ctdateOne',
        '产品名称':'title',
        '商城区域':'goodsTypeOne',
        '订单状态':'statusOne',
        '产品数量':'buyNum',
        '销售价':'minPrice',
        '采购价':'supplyPrice',
        '订单金额':'goodsAmount',
        '支付方式':'payPlatformOne',
        '渠道费':'fee',
        '会员UID':'userId',
        '是否可退货':'afterTypeOne',
      },
      listQuery: {
        page: 1,
        pageSize: 20,
        orderNo:null,
        goodsName: null,
        userId:null,
        financeStatus:null,
        goodsType:null,
        afterType:null,
        startTime: null, 
        endTime: null, 
      },
      option1:[
        {key:0,value:'未结算'},
        {key:1,value:'已结算'},
      ],
      option2:[
        {key:0,value:'普通'},
        {key:1,value:'优选区'},
        {key:2,value:'平价区'},
        {key:3,value:'积分兑换'},
        {key:4,value:'供应链区'},
      ],
      option3:[
        {key:0,value:'是'},
        {key:1,value:'否'},
      ],
      option4:{'alipay':'支付宝','wechat':'微信','balance':'余额'},
      option5:[
        {key:0,value:'待支付'},
        {key:1,value:'支付中'},
        {key:2,value:'待发货'},
        {key:3,value:'待收货'},
        {key:4,value:'交易成功'},
        {key:5,value:'交易关闭'},
        {key:6,value:'已退款'},
        {key:7,value:'已退货退款'},
        {key:8,value:'删除'}
      ],
      examineVisible: false, // 审核的弹框
      examineObj: {}, // 审核的弹框
      examineRules: {
        status: [
          { required: true, message: "提现结果不能为空", trigger: "change" }
        ]
      },
      examineForm: {
        id: 0, //
        status: null,
        // proof: [], // 打款凭证
        remark: null // 备注
      },
      ids:[],
      
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    getValue,
    async onFetch() {
      

    },
    handleSelectionChange(row){
      
      this.ids = [];
      row.forEach(item=>{
        if(item.financeStatus){
          this.$refs.table.toggleRowSelection(item);
        }else{
          this.ids.push(item.id);
        }
      })
    },
    setBatchSettlementOrder(arr = []){
      let params = {
        
      }

      if(!arr.length){
        if(this.ids.length){
          params['ids'] = this.ids;
        }else{
          this.$message({
            type: "error",
            message: "请先选择",
          });
            return;

        }
      }else{
        params['ids'] = arr;
      }
      batchSettlementOrder(params).then(res=>{
        if(res.bizcode == 100){
          this.$message({
            type: "success",
            message: "结算成功",
          });
          this.$refs.table.clearSelection();
          this.ids = [];
          this.getList();
        }
      })  
    },
    onTui(row){
      this.$confirm("是否同意退款, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let params = {
            outBillNo:row.transferBillNo
          }
          wechatCancelTransfer(params).then(res=>{
            if(res.bizcode == 100){
              this.$message({
                type: "success",
                message: "退款成功",
              });
              this.getList();
            }
            
          }).finally(() => {
              this.listLoading = false;
            });
         
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
      
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    /**
     * 查询列表
     */
    getList() {
      this.listLoading = true;
      let form = this.listQuery;
      if(form.orderNo && form.orderNo.indexOf('T') != -1){
        form.orderNo = form.orderNo.replace('T','')
      }
      const params = {
        ...form
      };
      getSettlementList(params)
        .then(response => {
          this.list = response.data.entitys;
          this.list.forEach(item=>{
            item.orderNo = `T${item.orderNo}`;
            item.financeStatusOne = this.option1[item.financeStatus].value;
            item.goodsTypeOne = this.option2[item.goodsType].value;
            item.afterTypeOne = this.option3[item.afterType].value;
            item.statusOne = this.option5[item.status].value;
            item.ctdateOne = formatApiDate(item.ctdate);
            item.payPlatformOne = this.option4[item.payPlatform];
          })
          
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    // 审核 start
    checkExamineVisible(val, obj = {}) {
      this.examineObj = obj;
      if (obj && Object.keys(obj).length !== 0) {
        this.examineForm.id = obj.id;
      }
      if (!val) {
        this.examineForm.id = 0;
        this.examineForm.status = null;
        // this.examineForm.proof = null;
        this.examineForm.remark = null;
        this.$refs.examineForm.resetFields();
      }
      this.examineVisible = val;
    },
    examineOk() {
      this.$refs["examineForm"].validate(valid => {
        if (valid) {
          const form = this.examineForm;
          const params = {
            ...form
          };
          // if (form.proof && form.proof.length !== 0) {
          //   const urlArr = form.proof.map(obj => obj["dbUrl"]);
          //   params.proof = urlArr.join(",");
          // }
          feedback(params).then((resp) => {
            if(resp && resp.bizcode === 100){
              this.getList();
              this.checkExamineVisible(false, {});
              this.$notify({
                title: "成功",
                message: "审核成功",
                type: "success",
                duration: 2000
              });
            }

          });
        }
      });
    },
    // 审核 end
    /**
     *  获取图片的值
     * @param type
     * @param value
     */
    getImgsValueFunc(type, value) {
      if (type === "proof") {
        this.examineForm.proof = value;
      }
    },
    /**
     * 获取时间
     * @param type
     * @param value
     */
    getPickerValueFunc(type, value) {
      if (type === "apply") {
        this.listQuery.startTime = value[0];
        this.listQuery.endTime = value[1];
      }
     
    },
    /**
     * 导出
     */
    handleExport() {
      const form = this.listQuery;
      const params = {
        ...form
      };
      exportOrderFinance(params).then(response => {
        uploadXlsx(response, "订单结算表");
      });
    }
  }
};
</script>
<style scoped lang="scss">
.el-dropdown-link {
  cursor: pointer;
  margin-left: 10px;
}
.comm_but_warp {
  margin-bottom: 10px;
}
</style>
